export default {
      id: "oc-rockbase-usage",
      viewBox: "0 0 256 256",
      url: __webpack_public_path__ + "sprite.svg#oc-rockbase",
      toString: function () {
        return this.url;
      }
    }